export enum RequestCategory {
    ALL = "all",
    PENDING = "pending",
    IN_PROGRESS = "inProgress",
    PROCESSED = "processed",
}

export type RequestSortProperty = Paths.ApiRequest.Get.Parameters.SortProperty;

export interface Request extends Omit<MyBrokerApi.UserRequest, "policyHolderId"> {
    policyholderId: number;
    documentsQuantity: number;
}

export interface SearchableRequest extends Request {
    updateDatetimeFormatted: string;
    // documentsQuantityLabel: string;
}

export interface RequestPagination extends Omit<MyBrokerApi.UserRequestPayload, "result"> {
    result: Request[];
}

export type RequestDocument = MyBrokerApi.RequestDocument;

export interface FamilyMember extends MyBrokerApi.FamilyMember {
    isPending?: boolean;
}

export type Relation = FamilyMember;

export const emptyAddress = {
    currentAddress: { addressDetail: {} },
    pendingAddress: { addressDetail: {} },
} as MyBrokerApi.AddressChangeRequest;

export interface WorkNature extends Omit<MyBrokerApi.WorkNature, "licensingDate" | "start" | "delivery"> {
    licensingDate: Date;
    start: Date;
    delivery: Date;
}

export interface TenYearsLiability extends Omit<MyBrokerApi.TenYearsLiability, "workNature"> {
    workNature: WorkNature;
}

export interface Independent extends Omit<MyBrokerApi.Independent, "birthdate"> {
    birthdate: Date;
}

export interface SalarySelfEmployed extends Omit<MyBrokerApi.SalarySelfEmployed, "independent" | "salary"> {
    independent: Independent;
    salary: Salary;
}

export interface Salary extends Omit<MyBrokerApi.Salary, "start" | "end"> {
    start: Date;
    end: Date;
}

export interface SalaryForm extends Omit<MyBrokerApi.SalaryForm, "start" | "end"> {
    start: Date;
    end: Date;
}

export const RELATION_TYPE_ID_SPOUSE = "07";
